<template>
    <div class="nav-rich-wrap" id="menu-destinations">
        <div class="fx-wrap">
            <div class="items">
                <ul>
                    <li v-for="(item, index) in items">
                        <a
                                :href=item.url
                                v-html="formatedItem(item.name, item.count, index)"
                                @mouseover="activeItem = index"
                        ></a>
                    </li>
                </ul>

            </div>
            <div class="thumb">
                <transition name="RichMenuImg" mode="in-out">
                    <img
                            v-for="(item, index) in items"
                            v-if="activeItem === index"
                            :key=index
                            :src=item.imgUrl :alt=item.alt
                    />
                </transition>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                activeItem: 0
            };
        },
        methods: {
            formatedItem(name, count, index) {
                return name + '<sup>' + count + '</sup>';
            }
        },
        created() {
        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/menus/RichMenuDestinations.vue